module.exports = __webpack_public_path__ + "img/t1.2be631c6.png";